import { render } from "./index.vue?vue&type=template&id=3b3ff43d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3b3ff43d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3ff43d"],['__file',"src/views/Home/Components/TopNotice/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b3ff43d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b3ff43d', __exports__)) {
    api.reload('3b3ff43d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3b3ff43d&scoped=true", () => {
    api.rerender('3b3ff43d', render)
  })

}


export default __exports__